export default function rowSizer (rows,query,desiredWidth){

    let results = []

    const getHeight = ({category,index}) => query[category][index].file.details.image.height;
    const getWidth = ({category,index}) => query[category][index].file.details.image.width;

    rows.forEach(row=>{
        let height = 0;
        let imgIndex;
        row.forEach(({category,index},i)=>{
            let tempHeight = getHeight({category,index});
            if ( height <= tempHeight){
                height = tempHeight
                imgIndex = i;
            }
        })
        let sizes;

        if(row.length > 1){
            sizes = [];
            let firstPhotoToScale = row[imgIndex];
            let imgToScaleBy = imgIndex === 0 ? 1 : 0;
            let ratio = getHeight(row[imgToScaleBy])/getHeight(firstPhotoToScale);

            let scaledDown = {
                height:getHeight(firstPhotoToScale) * ratio,
                width:getWidth(firstPhotoToScale) * ratio
            }
            sizes[imgIndex] = scaledDown;
            sizes[imgToScaleBy] = {
                height:getHeight(row[imgToScaleBy]),
                width:getWidth(row[imgToScaleBy])
            }
            let combinedWidth = sizes[0].width + sizes[1].width;
            let scalar =  combinedWidth / desiredWidth;

            sizes = sizes.map(({width:w,height:h})=>(
                    {
                        height:h/scalar,
                        width:w/scalar
                    }
                )
            );
            results.push(sizes);

         }
        else{
            results.push(undefined)
        }

    });
    return results;
}
